import {
    TECH_DOC_DOWNLOAD_PRESIGNED_URL,
    TECH_DOC_CREATE_ATTACHMENTS,
} from '../../constants/websocketCommands';
import {extractErrorText} from '../actionUtils';
import {errorAlert} from '../alertsActions';
import {uploadTechDocAttachment} from '../../api/techDoc/restTechDocAttachments';
import alertMessages from '../../intl/common/alertMessages';

export const TECH_DOC_ATTACHMENTS_UPLOADING_ERROR = 'TECH_DOC_ATTACHMENTS_UPLOADING_ERROR';
export const TECH_DOC_ATTACHMENTS_UPLOADING = 'TECH_DOC_ATTACHMENTS_UPLOADING';

export const startUploadAttachments = () => dispatch => {
    return dispatch({type: TECH_DOC_ATTACHMENTS_UPLOADING});
};

export const downloadAttachment = (uuid, ticketId, name) => dispatch => {
    return dispatch({
        type: TECH_DOC_DOWNLOAD_PRESIGNED_URL,
        techDocWebsocket: true,
        command: TECH_DOC_DOWNLOAD_PRESIGNED_URL,
        payload: {
            attachment: {
                uuid,
                ticketId,
                name
            }
        }
    });
};

export const uploadAttachments = (attachments, correlationId, solutionGroup) => dispatch => {
    const promises = [];
    const savedAttachments = [];
    attachments.forEach(attachment => {
        promises.push(
            uploadTechDocAttachment(attachment.url, attachment.localUrl, attachment.name, attachment.contentType).then(
                () => {
                    window.URL.revokeObjectURL(attachment.localUrl);
                    savedAttachments.push(attachment);
                }, error => {
                    dispatch({type: TECH_DOC_ATTACHMENTS_UPLOADING_ERROR});
                    dispatch(errorAlert(...extractErrorText(error, alertMessages.FILE_UPLOAD_ERROR)));
                }
            )
        )
    });
    return Promise.all(promises).then(() => {
            if (savedAttachments.length > 0) {
                dispatch({
                    type: TECH_DOC_CREATE_ATTACHMENTS,
                    techDocWebsocket: true,
                    command: TECH_DOC_CREATE_ATTACHMENTS,
                    payload: {
                        attachments: savedAttachments,
                        correlationId,
                        uuid: savedAttachments[0].ticketId,
                        solutionGroup
                    }
                })
            } else {
                dispatch({
                    type: TECH_DOC_ATTACHMENTS_UPLOADING_ERROR,
                })
            }
        }
    )
};
